import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

/**
 * Shared shape for the two tick-list sections the document defines the same
 * way — "Our Consulting Approach" and "Why Work With MBA Solutions Team?":
 * heading, sub-heading, a lead-in line, a run of ticked items, a closing line.
 */
const TeamChecklist = ({ id, content, items, tone = "light" }) => (
  <section
    className={`${tone === "light" ? "bg-white" : "bg-gray-50"} py-14 lg:py-20`}
    aria-labelledby={id}
  >
    <div className="brand-col">
      <SectionHeading id={id} title={content.title} subtitle={content.subtitle} />
      <p className="mx-auto -mt-4 mb-8 max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
        {content.intro}
      </p>
      <motion.ul
        className="mx-auto grid max-w-4xl list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
      >
        {items.map((item) => (
          <motion.li
            key={item}
            variants={itemVariants}
            className="flex items-start gap-3 rounded-xl border border-gray-100 bg-white p-4 shadow-sm"
          >
            <FiCheckCircle
              aria-hidden="true"
              size={20}
              className="mt-0.5 flex-shrink-0 text-[var(--brand-primary)]"
            />
            <span className="text-sm md:text-base text-gray-700">{item}</span>
          </motion.li>
        ))}
      </motion.ul>
      <p className="mx-auto mt-8 max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
        {content.outro}
      </p>
    </div>
  </section>
);

export default TeamChecklist;
